import { useURLParams } from '@/lib/navigation/useURLParams'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Tag } from '@/ui/tag/Tag.client'
import { TagGroup } from '@/ui/tag/TagGroup.client'
import { Title } from '@/ui/text/title/Title'
import type { ProductListActiveFiltersFragment } from '@gql-generated/graphql'
import { useSetAtom } from 'jotai'
import { isProductListPageLoadingAtom } from '../../services/productList.store'

type ProductListActiveFilterProps = {
  activeFilters: ProductListActiveFiltersFragment
}

export function ProductListActiveFilter({ activeFilters }: ProductListActiveFilterProps) {
  const { setURLParams } = useURLParams()
  const { title, values } = activeFilters

  const setIsProductListPageLoading = useSetAtom(isProductListPageLoadingAtom)

  const handleDelete = (request: string, label: string, productCount: number) => {
    setURLParams([
      { name: 'filter', value: request },
      { name: 'p', value: '1' },
    ])
    setIsProductListPageLoading(true)
    pushToGtmDataLayer({
      event: 'gaEvent',
      eventCategory: 'filtres',
      eventAction: 'suppression filtre - ' + label,
      eventLabel: productCount.toString(),
    })
  }

  if (!values || values.length === 0) return null

  return (
    <div className="flex flex-col gap-0.5">
      <Title as="h3" size="sm" className="font-bold uppercase text-primary">
        {title}
      </Title>
      <TagGroup
        size="md"
        aria-label={title}
        items={values}
        onRemove={(keys) => {
          const removedItems = values.filter((item) => keys.has(item.title))

          for (const item of removedItems) {
            handleDelete(item.link.value, item.title, item.productCount)
          }
        }}
      >
        {(item) => (
          <Tag id={item.title} key={item.title}>
            {item.title}
          </Tag>
        )}
      </TagGroup>
    </div>
  )
}
